import { Component, HostListener, Input, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { countryCodesList } from 'src/assets/data/countries';
import { MatSort } from '@angular/material/sort';
import { SupplierAssistantModel } from 'src/app/models/supplier-assistant.model';
import { PhoneModel } from 'src/app/models/phone.model';
import { ContainerAnimations } from 'src/app/shared/animations/container-animation';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/shared/services/user.service';
import { SupplierService } from 'src/app/services/supplier.services';
import { MatPaginator } from '@angular/material/paginator';
import { SharedServices } from 'src/app/shared/services/shared.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { SupplierModel } from 'src/app/models/supplier.model';
import { DatePipe, NgClass } from '@angular/common';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { MatInput, MatError, MatSuffix } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSelect, MatSelectTrigger, MatOption } from '@angular/material/select';
import { escapeBelongsToOverlay } from '../escape-key';

@Component({
    selector: 'app-supplier-profile-assistant',
    templateUrl: './suplier-assistant.component.html',
    styleUrls: ['./suplier-assistant.component.scss'],
    animations: [ContainerAnimations.height],
    imports: [NgClass, IconMenuButtonComponent, MatMenu, MatMenuItem, FormsModule, ReactiveFormsModule, MatInput, MatError, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatSelect, MatSelectTrigger, MatOption, DatePipe]
})
export class SupplierAssistantProfileComponent implements OnInit {
  imageSvc = inject(ImageService);
  private readonly supplierService = inject(SupplierService);
  usrSvc = inject(UserService);
  private readonly router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  toastr = inject(ToastService);
  sharedService = inject(SharedServices);
  datepipe = inject(DatePipe);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);

  supplierAssistantForm = new UntypedFormGroup({});
  supplerAssistList: SupplierAssistantModel[] = [];
  /** True once GET assistants answered: the empty message is not shown while loading. */
  assistantsLoaded = false;
  supplierAssistantToEdit: SupplierAssistantModel | null = null;
  @Input() supplier!: SupplierModel;
  showAssistantForm: boolean = false;

  suppName: any;
  countryCodesList: any[] = countryCodesList;
  selectedCode: {} = {};
  selectedflag: string = '';
  maxDate: Date = new Date();


  supplierId!: string;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit() {
    this.initCollaboratorForm();
    this.selectedflag = this.countryCodesList.find((x) => x.code == 'AR').src;
    // Loaded here (the supplier input is already set) so a cached answer renders in the first check.
    this.supplierId = this.supplier.id.toString();
    this.getAssistants(this.supplierId);
  }

  initCollaboratorForm() {
    this.supplierAssistantForm = new UntypedFormGroup({
      id: new UntypedFormControl(Guid.EMPTY),
      fullName: new UntypedFormControl('', [
        Validators.required,
        // Any letter (accents, ñ...), spaces, apostrophes and hyphens, like the supplier's own name.
        Validators.pattern(/^[\p{L}\p{M}\s'-]+$/u),
        Validators.maxLength(50),
      ]),
      dni: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{7,8}$'),
      ]),
      birthDate: new UntypedFormControl('', [Validators.required]),
      phoneNumber: this.createPhone(),
      isActive: new UntypedFormControl(true),
    });

    this.supplierAssistantToEdit = null;
  }

  getAssistants(id: string) {
    this.supplierService
      .getAllAssistant(id)
      .subscribe((data: SupplierAssistantModel[]) => {
        this.supplerAssistList = data;
        this.assistantsLoaded = true;
      });
  }

  editAssistant(model: SupplierAssistantModel) {
    this.openAssistantForm(model);
    this.supplierService
      .getAssistant(model.id.toString())
      .subscribe((model: SupplierAssistantModel) => {
        this.supplierAssistantToEdit = model;
        this.supplierAssistantForm.setValue(model);
      });
  }

  deleteAssistant(supplierAssistant: SupplierAssistantModel) {
    this.swalFire
      .SwalFireQuestion(
        'Eliminación',
        '¿Desea eliminar este colaborador?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.supplierService
            .deleteAssistant(supplierAssistant.id.toString())
            .subscribe(
              (data) => {
                this.toastr.success(
                  'Actualización',
                  'El colaborador se eliminó correctamente.'
                );
                this.getAssistants(this.supplierId);
              },
              (err) => {
                this.toastr.error(
                  'Error',
                  'No se pudo eliminar el colaborador.'
                );
              }
            );
        }
      });
  }

  changeSelection(countryCode: any) {
    this.selectedflag = this.countryCodesList.find(
      (x) => x.countryCode == countryCode
    ).src;
  }

  openAssistantForm(assist?: SupplierAssistantModel) {
    this.showAssistantForm = true;
    if (!assist) this.initCollaboratorForm();
  }

  formatPhone(phoneNumber: PhoneModel) {
    if (!phoneNumber?.number) {
      return '';
    }
    return `${phoneNumber.countryCode}-${phoneNumber.number}`;
  }

  formatDate(date: Date) {
    if (!date) {
      return '';
    }
    return date.toString().split('T')[0];
  }

  onSubmit() {
    let model = this.supplierAssistantForm.value as SupplierAssistantModel;

    if (this.supplierAssistantForm.invalid) {
      // An empty or wrong form used to do nothing at all: show what is missing.
      this.supplierAssistantForm.markAllAsTouched();
      this.toastr.error('Error', 'Revise los campos obligatorios del formulario.');
      return;
    }

    if (this.supplierAssistantForm.valid) {
      model.phoneNumber.number = model.phoneNumber.number?.toString();
      model.dni = model.dni.toString();

      if (model.id.toString() != Guid.EMPTY) {
        this.supplierService
          .patchAssistant(model.id.toString(), model)
          .subscribe({
            next: (data) => {
              this.toastr.success(
                'Actualización',
                'El colaborador se ha actualizado correctamente.'
              );
              this.getAssistants(this.supplierId);
              this.closeAssistanForm();
            },
            error: (err) => {
              this.toastr.error('Error', 'No se pudo registar el colaborador.');
            },
          });
      } else {
        this.supplierService.postAssistant(this.supplierId, model).subscribe({
          next: (data) => {
            this.toastr.success(
              'Registración',
              'El colaborador se ha registrado correctamente.'
            );
            this.getAssistants(this.supplierId);
            this.closeAssistanForm();
          },
          error: (err) => {
            this.toastr.error('Error', 'No se pudo registar el colaborador.');
          },
        });
      }
    }
  }

  createPhone(): UntypedFormGroup {
    return new UntypedFormGroup({
      countryCode: new UntypedFormControl('+54', [Validators.required]),
      areaCode: new UntypedFormControl(' '),
      number: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{10,10}$'),
      ]),
      isMobile: new UntypedFormControl(true),
    });
  }

  activateDeactivate(supplierAssistant: SupplierAssistantModel) {
    this.supplierService
      .activateAssistant(
        supplierAssistant.id.toString(),
        !supplierAssistant.isActive
      )
      .subscribe(
        (data) => {
          supplierAssistant.isActive = !supplierAssistant.isActive;
        },
        (err) => {
          let msg = supplierAssistant.isActive ? 'activar' : 'desactivar';
          this.toastr.error(
            'Error',
            'No se ha podido ' + msg + ' el prestador.'
          );
        }
      );
  }

  @HostListener('window:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    // Escape on the open country dropdown or datepicker closes only that overlay.
    if (this.showAssistantForm && !escapeBelongsToOverlay(event)) {
      this.closeAssistanForm();
    }
  }

  closeAssistanForm() {
    this.supplierAssistantToEdit = null;
    this.supplierAssistantForm.reset();
    this.showAssistantForm = false;
  }
}
